export default {
    api_host: 'https://appcenter.ziqva.com/landingapi',
    site_name: "Ziqva Labs",
    description_default: "Ziqva, kumpulan software dropship terbaik dari perusahaan Kampung Songo. Dapatkan tools dan informasi terbaru untuk memudahkan bisnis dropshipping Anda."
}